export const COLLECTION_NAMES = {
  USER: 'user',
  USER_LIKE: 'user_like',
  ADDRESS: 'address',
  CONFIGS: 'configs',
  FAQ: 'faq',
  BANNER_PRIMARY: 'banner_primary',
  BANNER_SECONDARY: 'banner_secondary',
  CATEGORY: 'category',
  CATEGORIES: 'categories',
  SCHOOL: 'school',
  SALE: 'sale',
  BANKING_STATEMENT: 'bank_statement',
  NOTIFICATION: 'notification',
  ORDER: 'order',
  VIEWS: 'views',
  REFUND: 'refund',
  CHAT: 'chat',
  MESSAGE: 'message',
  LOGS: 'log',
};

export const CONFIGS_NAMES = {
  WITHDRAW: 'withdraw',
};
